import React from 'react';
import { Row, Col, Switch, Button, Tooltip } from 'antd';
import { onSetSmartPiSwitches, onGetSmartPiSwitches, onSetSmartPiSolar } from '../../data/homes/actions';

class SmartPiSwitches extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bits: '00000000',
            version: 'Version: Unknown',
            message: 'Change bits ...',
            solar: '000'
        };
    }

    componentWillMount() {
        onGetSmartPiSwitches(this.setBits);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    setBits = data => {
        if(data) this.refresh(data);
        this.timeout = setTimeout(() => {
            onGetSmartPiSwitches(this.setBits);
        }, 1000);
    };

    change = (id, checked) => {
        const { bits } = this.state;
        let newBits = '';
        for (let i = 0; i < 8; i += 1) {
            if (i === id) newBits += checked ? '1' : '0';
            else newBits += bits.substr(i, 1);
        }
        this.setState({
            bits: newBits,
            version: '',
            message: 'Please wait ...'
        });
        // console.log(newBits);
        onSetSmartPiSwitches(newBits, this.refresh);
    };

    command = (cmd, index = 0) => {
        const { solar } = this.state;
        let SOLAR = '';
        for(let i = 0; i<solar.length; i+=1)
            SOLAR += i === index ? 'X' : solar[i];
        this.setState({
            solar: SOLAR
        });
        onSetSmartPiSolar(cmd, this.refresh);
    };

    changeRow = (b1, b2, b3) => {
        const { bits } = this.state;
        const checked = bits[b1] === '1';
        let newBits = '';
        for (let i = 0; i < 8; i += 1) {
            if (i === b1 || i === b2 || i === b3) newBits += checked ? '0' : '1';
            else newBits += bits.substr(i, 1);
        }
        this.setState({
            bits: newBits,
            version: '',
            message: 'Please wait ...'
        });
        onSetSmartPiSwitches(newBits, this.refresh);
    };

    refresh = data => {
        console.log(data);
        this.setState({
            version: `Version: ${data.version}`,
            message: data.message,
            bits: data.state,
            solar: data.SCO
        });
    };

    render() {
        const { version, message, bits, solar } = this.state;

        const eexState = solar && solar[3] === '1' ? 'primary' : '';
        const sunState = solar && solar[0] === '1' ? 'primary' : '';
        const cloudState = solar && solar[1] === '1' ? 'primary' : '';
        const optimizationState = solar && solar[2] === '1' ? 'primary' : '';

        const eexIcon = solar && solar[3] === 'X' ? 'loading' : 'stock';
        const sunIcon = solar && solar[0] === 'X' ? 'loading' : 'bulb';
        const cloudIcon = solar && solar[1] === 'X' ? 'loading' : 'cloud';
        const optimizationIcon = solar && solar[2] === 'X' ? 'loading' : 'euro';

        return (
            <div style={{
                display: 'flex'
            }}>
                <div
                    style={{
                        maxWidth: '210px',
                        marginLeft: 'auto',
                        marginRight: '10px',
                        marginTop: '30px',
                        padding: '20px',
                        border: '1px solid #DDD',
                        borderRadius: '1em'
                    }}
                >
                    <Row>
                        <Col span={3} />
                        <Col span={7} style={{ textAlign: 'center' }}>
                            <h4>1</h4>
                        </Col>
                        <Col span={7} style={{ textAlign: 'center' }}>
                            <h4>2</h4>
                        </Col>
                        <Col span={7} style={{ textAlign: 'center' }}>
                            <h4>3</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={3}>
                            <h4>P1</h4>
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[0] === '1'}
                                onChange={checked => {
                                    this.change(0, checked);
                                }}
                            />
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[1] === '1'}
                                onChange={checked => {
                                    this.change(1, checked);
                                }}
                            />
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[2] === '1'}
                                onChange={checked => {
                                    this.change(2, checked);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={3}>
                            <h4>P2</h4>
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[3] === '1'}
                                onChange={checked => {
                                    this.change(3, checked);
                                }}
                            />
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[4] === '1'}
                                onChange={checked => {
                                    this.change(4, checked);
                                }}
                            />
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[5] === '1'}
                                onChange={checked => {
                                    this.change(5, checked);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={3}>
                            <h4>P3</h4>
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[6] === '1'}
                                onChange={checked => {
                                    this.change(6, checked);
                                }}
                            />
                        </Col>
                        <Col span={7}>
                            <Switch
                                checked={bits[7] === '1'}
                                onChange={checked => {
                                    this.change(7, checked);
                                }}
                            />
                        </Col>
                        <Col span={7} />
                    </Row>
                    <Row>
                        <Col span={3} />
                        <Col span={7}>
                            <Button style={{
                                width: '1.5em',
                                height: '1.5em',
                                borderRadius: '1em'
                            }} onClick={() => this.changeRow(0, 3, 6)} />
                        </Col>
                        <Col span={7}>
                            <Button style={{
                                width: '1.5em',
                                height: '1.5em',
                                borderRadius: '1em'
                            }} onClick={() => this.changeRow(1, 4, 7)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            span={24}
                            style={{
                                marginTop: '30px',
                                marginBottom: '30px',
                                textAlign: 'center'
                            }}
                        >

                            <Tooltip placement="left" title="Eex">
                                <Button type={eexState} size="large" shape="circle" icon={eexIcon} style={{margin: 2}} onClick={() => this.command('eex', 3)} />
                            </Tooltip>

                            <Tooltip placement="top" title="Sun">
                                <Button type={sunState} size="large" shape="circle" icon={sunIcon} style={{margin: 2}} onClick={() => this.command('sun', 0)} />
                            </Tooltip>

                            <Tooltip placement="right" title="Cloud">
                                <Button type={cloudState} size="large" shape="circle" icon={cloudIcon} style={{margin: 2}} onClick={() => this.command('cloud', 1)} />
                            </Tooltip>

                            <Tooltip placement="bottom" title="Optimization">
                                <Button type={optimizationState} size="large" shape="circle" icon={optimizationIcon} style={{margin: 2}} onClick={() => this.command('optimize', 2)} />
                            </Tooltip>

                        </Col>
                    </Row>
                    <Row>
                        <Col
                            span={24}
                            style={{
                                marginTop: '20px',
                                textAlign: 'center'
                            }}
                        >
                            <h4>{version}</h4>
                            <h4>{message}</h4>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        maxWidth: '270px',
                        marginRight: 'auto',
                        marginTop: '30px',
                        padding: '5px',
                        border: '1px solid #DDD',
                        borderRadius: '1em'
                    }}
                >
                    <img style={{
                        borderRadius: '1em'
                    }} width="100%" src="/dist/image/testboard.jpg" />
                </div>
            </div>
        );
    }
}

export default SmartPiSwitches;
